<template>
  <ul class="Tag-List">
    <li class="Tag-List__item" v-for="(item, key) in props.list">
      {{ key }} <span class="Tag-List__value">{{ item }}</span>
    </li>
  </ul>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  //-----------------------------------------------
  const props = defineProps(Props());
  //-----------------------------------------------
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>